import * as React from 'react';

import moment from 'moment';

import {isToday} from 'nutshell-core/date-time';

import {FormattedTimestamp} from '../timestamp/formatted-timestamp';
import {RelativeTimestamp} from '../timestamp/relative-timestamp';

export function getSendTimestamp(sendTime: number) {
    const timeNow = Date.now() / 1000;
    const isLessThanTenMinutes = sendTime - timeNow < 10;

    if (isLessThanTenMinutes) {
        return 'soon';
    }

    if (isToday(moment.unix(sendTime))) {
        return <RelativeTimestamp datetime={sendTime} />;
    }

    return (
        <>
            on&nbsp;
            <FormattedTimestamp
                datetime={sendTime}
                format={FormattedTimestamp.formats.longMonthDay}
            />
        </>
    );
}
